import {useGrpcRequest} from '@aboutyou/data-fetcher';
import {StoryPageService_GetHeaderLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/story_page/v1/service.grpc.lazy';
import {useStoryIdFromUrl} from '../../utils/useStoryIdFromUrl';

export const useGetStoryHeader = () => {
  const storyId = useStoryIdFromUrl();

  return useGrpcRequest(
    StoryPageService_GetHeaderLazy,
    {
      storyId: storyId!,
    },
    {
      keepPreviousData: true,
      disabled: !storyId,
      mockData: async () =>
        import('../__mocks__/getStoryHeaderMock').then(module =>
          module.getStoryHeaderMock(),
        ),
    },
  );
};
